import { Button, Modal, Form, Row, Col, Input, message, Select } from "antd";
import { useMutation } from "@tanstack/react-query";
import { handleUpdateUser } from "../../../api/user";
import { useEffect } from "react";

const { Option } = Select;

export default function UpdateUser({
  isVisible,
  setVisible,
  company,
  user,
  refetch,
}: any) {
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleUpdateUser,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      refetch();
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      company: company?._id,
      ...values,
    };

    await mutate({ data, _id: user?._id });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({ accessLevel: user?.accessLevel || 1 });
    form.setFieldsValue({ name: user?.name });
    form.setFieldsValue({ email: user?.email });
    form.setFieldsValue({ mobile: user?.mobile });
    form.setFieldsValue({ role: user?.role });
  }, [user]);

  return (
    <Modal
      open={isVisible}
      title="Update Member"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input type="" placeholder="Name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Please enter email",
                },
              ]}
            >
              <Input type="" placeholder="Email" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label="Mobile"
              rules={[
                {
                  required: true,
                  message: "Please enter mobile",
                },
              ]}
            >
              <Input type="" placeholder="Mobile" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="role"
              label="Role"
              rules={[
                {
                  required: true,
                  message: "Please select role",
                },
              ]}
            >
              <Select placeholder="Role">
                <Option value="Organizer">Organizer</Option>
                <Option value="Instructor">Instructor</Option>
                <Option value="Manager">Manager</Option>
                <Option value="Service Advisor">Service Advisor</Option>
                <Option value="Technician">Technician</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="accessLevel"
              label="Access Level"
              rules={[
                {
                  required: true,
                  message: "Please select access level",
                },
              ]}
            >
              <Select placeholder="Access Level">
                <Option value={1}>Level 1</Option>
                <Option value={2}>Level 2</Option>
                <Option value={3}>Level 3</Option>
                <Option value={4}>Level 4</Option>
                <Option value={5}>Level 5</Option>
                <Option value={6}>Level 6</Option>
                <Option value={7}>Level 7</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
